import { useParams } from "react-router-dom";

import { ProductsTable } from "../../ProductsTable";

export function FacilityProduct() {
  const { facilityId = "" } = useParams<{ facilityId: string }>();

  return <ProductsTable facilityId={facilityId} showReportingYearPicker />;
}
